import React, {useEffect, useState} from "react";
import {Images, ScreenId, Svgs} from "@assets";
import styles from "./style.module.scss";
import {useNav} from "@hook";
import {api, constant} from "@utils";
import {Modal} from "@adminComponents";

export default function Component() {
  const {navigate} = useNav();
  const isTablet = window.innerWidth < constant.TABLET_WIDTH;
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [reviewCnt, setReviewCnt] = useState(0);

  function toggleSideMenu() {
    setIsSideMenuOpen(!isSideMenuOpen);
  }

  function closeSideMenu() {
    setIsSideMenuOpen(false);
  }

  async function getReviewCount() {
    try {
      const {success, data} = await api.v1.review.getCount();
      if (success) {
        setReviewCnt(Number(data));
      }
    } catch (error) {
      console.error("getReviewCount error", error);
    }
  }

  useEffect(() => {
    getReviewCount();
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.logo}
          onClick={() => navigate({url: ScreenId.HOME})}>
          <Svgs.Logo />
        </div>
        <div className={styles.menu}>
          <div
            className={styles.menuItem}
            onClick={() => navigate({url: ScreenId.HOME})}>
            리브 온 라이프
          </div>
          <div
            className={styles.menuItem}
            onClick={() =>
              navigate({
                url: ScreenId.HOME,
                scrollId: constant.HOME_PRODUCT_DIV_ID,
              })
            }>
            장례상품
          </div>
          <div
            className={styles.menuItem}
            onClick={() => navigate({url: ScreenId.REVIEW})}>
            장례후기 <span>{reviewCnt.toLocaleString()}</span>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <button
            className={styles.kakaoBtn}
            onClick={() => window.open(constant.LINK.KAKAOTALK)}>
            <img src={Images.kakaoIcon} alt="kakaotalk" />
            <span>카카오톡 채팅상담</span>
          </button>
          <button className={styles.telBtn} onClick={constant.CS_CLICK}>
            24시간 고객상담
          </button>
        </div>
        <button className={styles.menubtn} onClick={toggleSideMenu}>
          <Svgs.Menu />
        </button>
      </div>
      {!!isTablet && (
        <SideMenu
          visible={isSideMenuOpen}
          close={closeSideMenu}
          reviewCnt={reviewCnt}
        />
      )}
    </>
  );
}

function SideMenu({
  visible,
  close,
  reviewCnt,
}: {
  visible: boolean;
  close?: () => void;
  reviewCnt: number;
}) {
  const {navigate} = useNav();

  return (
    <Modal
      isVisible={visible}
      close={close}
      animate="left"
      width="100vw"
      height="100vh"
      className={styles.modalContainer}>
      <div className={styles.modal}>
        <div className={styles.titowRow}>
          <Svgs.Logo />
          <div className={styles.close} onClick={close}>
            <Svgs.Close />
          </div>
        </div>
        <div className={styles.menu}>
          <div
            className={styles.menuItem}
            onClick={() => {
              navigate({url: ScreenId.HOME});
              close?.();
            }}>
            리브 온 라이프
          </div>
          <div
            className={styles.menuItem}
            onClick={() => {
              navigate({
                url: ScreenId.HOME,
                scrollId: constant.HOME_PRODUCT_DIV_ID,
              });
              close?.();
            }}>
            장례상품
          </div>
          <div
            className={styles.menuItem}
            onClick={() => {
              navigate({url: ScreenId.REVIEW});
              close?.();
            }}>
            장례후기 <span>{reviewCnt}</span>
          </div>
          <div className={styles.menuItem} onClick={constant.CS_CLICK}>
            24시간 고객상담
          </div>
          <button
            className={styles.kakaoBtn}
            onClick={() => window.open(constant.LINK.KAKAOTALK)}>
            <img src={Images.kakaoIcon} alt="kakaotalk" />
            <span>카카오톡 채팅상담</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
